<span class="govuk-!-margin-bottom-0 govuk__nowrap">
  <ng-container *ngIf="num !== null">
    <strong class="govuk-line-height__normal govuk-!-margin-right-1">{{ num }}</strong>
  </ng-container>
  <img src="/assets/images/{{ icon }}.svg" class="asc-icon-align" alt="" />
  <span class="govuk-!-margin-left-1">{{ label }}</span>
</span>
